import Inputmask from "inputmask/lib/inputmask";

function inputMaskInit(elements) {
    $(elements).each((i, el) => {
       const $el = $(el);
       const mask = new Inputmask({
           placeholder: '',
           removeMaskOnSubmit: !$(el).data('no-remove-submit')
       });
       mask.mask(el);
    });
}

export default function (elements) {
    inputMaskInit(elements);
}